import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/XhsAccountInterest.graphql';
import { Query, QueryxhsAccountInterestArgs } from '../../__generated__/globalTypes';

export const useXhsAccountInterestQuery = (options?: QueryHookOptions<Query, QueryxhsAccountInterestArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryxhsAccountInterestArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useXhsAccountInterestLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryxhsAccountInterestArgs>
): QueryResult<Query, QueryxhsAccountInterestArgs> & {
  getXhsAccountInterest: LazyQueryExecFunction<Query, QueryxhsAccountInterestArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getXhsAccountInterest, result] = useLazyQuery<Query, QueryxhsAccountInterestArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getXhsAccountInterest, ...result };
};

export const useXhsAccountInterestPromiseQuery = () => {
  const client = useApolloClient();

  const getXhsAccountInterest = useCallback(
    (options?: Omit<QueryOptions<QueryxhsAccountInterestArgs, Query>, 'query'>) =>
      client.query<Query, QueryxhsAccountInterestArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getXhsAccountInterest };
};
// Suspense Query Hooks
export const useXhsAccountInterestSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryxhsAccountInterestArgs>
) => {
  const result = useSuspenseQuery<Query, QueryxhsAccountInterestArgs>(QUERY, {
    ...options
  });

  return result;
};
